import React, { useEffect, useMemo, useState } from "react";

import {
   isHoppyOrGamification,
   mobileStartActionByUrl,
   mobileStartFlutterActionByUrl
} from "@util/Scripts";
import { useSelector, useDispatch } from "react-redux";
import { setChatSettings } from "../../appRedux/actions/ChatSettings";
import { saveRecord } from "services/api/Api";
import { useHistory } from "react-router";
import { setBackUrl } from "../../appRedux/actions/Auth";

import moment from "moment";
import ActionModal from "./ActionModal";

import "./actionsDropdown.less";
import CreateChat from "../Widgets/WidgetsSettings/ChatSettings/CreateChat";
import { Button, Dropdown, Menu } from "../BP2Components";

//DEPRACATED, used only in basket
const ActionsDropdown = (props) => {
   const [dataSubTitleIndex] = useState("");
   const [dataTitleIndex] = useState("");
   const [allActions, setAllActions] = useState([...props.actions]);
   const [setActualChatButtonTranslation] = useState();
   const [isDropdownOpen, setIsDropdownOpen] = useState(false);

   const { authUser } = useSelector(({ auth }) => auth);
   const { platformToken, platform } = useSelector(({ user }) => user);
   const { chatSettings } = useSelector(({ chatSettings }) => chatSettings);
   const { locale } = useSelector(({ settings }) => settings);

   const history = useHistory();
   const dispatch = useDispatch();

   const userId = authUser.oldId;
   const click = "click";

   useEffect(() => {
      if (props?.actualTranslations && props?.isChatButtonVisible) {
         const settingsTranslations = props?.actualTranslations?.find(
            (translObj) => translObj?.key === props?.chatTitleKey
         );
         if (settingsTranslations && settingsTranslations?.values[locale]) {
            setActualChatButtonTranslation(settingsTranslations?.values[locale]);
         }
      }
      //pushing chat button to action list
      if (props?.chatTitleKey) {
         if (
            props?.isChatButtonVisible === true &&
            allActions.find((button) => button?.type === "chat") === undefined
         ) {
            setAllActions((prevAction) => {
               return [
                  ...prevAction,
                  {
                     label: props?.chatTitleKey,
                     type: "chat",
                     isChatButtonVisible: props?.isChatButtonVisible
                  }
               ];
            });
         } else if (props?.isChatButtonVisible === false) {
            setAllActions([...props.actions]);
         }
      }
   }, [props]);

   useEffect(() => {
      // "api_recordactions" is a default value after refreshing and reloading page
      if (dataTitleIndex !== "api_recordactions" && dataSubTitleIndex !== "api_recordactions") {
         dispatch(
            setChatSettings({
               ...chatSettings,
               dataTitle: dataTitleIndex,
               dataSubTitle: dataSubTitleIndex
            })
         );
      }
   }, [dataTitleIndex, dataSubTitleIndex]);

   const handleSave = () => {
      let values = props.row;
      const dataVal = {};
      props.columns.forEach((column) => {
         const atrr = column.attribute.split(".");
         const attributeName = atrr[1];
         if (attributeName && atrr[0] === props.dataModelName) {
            if (values[column.dataIndex] === null) {
               dataVal[attributeName] = null;
            } else {
               dataVal[attributeName] =
                  typeof values[column.dataIndex] === "object"
                     ? +values[column.dataIndex].id
                     : values[column.dataIndex];
            }
         }
         if (attributeName === "removal_time") {
            const reservationTime = values["czas rezerwacji"];
            const data = moment().add(parseInt(reservationTime, 10), "seconds");
            dataVal[attributeName] = data.format("YYYY-MM-DD h:mm:ss");
         }
      });
      dataVal.application_status = 2;
      dataVal.user_id = userId;
      const id = dataVal.id;
      delete dataVal.id;
      saveRecord(props.dataModelName, dataVal, id);
      props.toggle();
   };

   const handleClick = (e) => {
      if (e?.processId) {
         if (e?.label && e?.type === "PROCESS") {
            const recordId = props?.row?._sysRecordId
               ? props?.row?._sysRecordId
               : props?.row?.api_rowMetaData?.recordId;
            let link;
            // TODO FIX THIS LATER - RIGHT NOW WE DON'T HAVE OTHER INFO THAN LABEL
            // Im leaving dataModelName etc. for Kamil Wiczkowski, if he upgrades app to new endpoint then we
            // will be able to change it to link with only recordId + actionId
            if (e?.label !== "Uruchom") {
               if (e?.processId === "recordId") {
                  link = `/cases/${recordId}?processId=${recordId}&dataModelName=${props?.dataModelName}&dataId=${recordId}&actionId=${e.id}`;
               } else {
                  link = `/cases/${e?.processId}?processId=${e?.processId}&dataModelName=${props?.dataModelName}&dataId=${recordId}&actionId=${e.id}`;
               }
            } else {
               // This would be final link, other will be removed
               link = `/cases/${recordId}?processId=${recordId}&actionId=${e.id}`;
            }
            if (e?.recordIdTargetModel && e?.recordIdTargetModelAttribute) {
               const targetModel = `&model=${e?.recordIdTargetModel}&attr=${e?.recordIdTargetModelAttribute}&dataId=${recordId}&actionId=${e.id}`;
               link = `/cases/${e?.processId}?processId=${e?.processId}${targetModel}`;
            }
            mobileStartActionByUrl(link);
            mobileStartFlutterActionByUrl("startActionByUrl", link);
            dispatch(setBackUrl(window.location.pathname));
            window.location.assign(window.location.origin + link);
         }
      }
      if (e?.label === "Nawiguj") {
         const navUrlWithCoordinates = `${e?.navUrl}${props?.row?.clientCoordinates
            .split(" ")
            .join("")}`;

         mobileStartActionByUrl(navUrlWithCoordinates);
         mobileStartFlutterActionByUrl("startActionByUrl", navUrlWithCoordinates);
         history.push(navUrlWithCoordinates);
      }

      if (e?.url) {
         const urlLink = atob(e?.url);
         const finalURL = urlLink.replace("RECORD_ID", props?.id);
         const text = finalURL.replace("%7Bjwt%7D", platformToken);
         history.push(platform + text);
      }
   };

   const menu = useMemo(
      () => (
         <Menu>
            {allActions.map((action, index) => (
               <Menu.Item key={action.id ?? index} itemKey={action.id ?? index}>
                  {action?.type === "FORM" ? (
                     <ActionModal
                        action={action}
                        props={props}
                        actualTranslations={props.actualTranslations}
                        onlyItem={props.isButtons}
                     />
                  ) : action?.type === "chat" ? (
                     <CreateChat
                        action={action}
                        props={props}
                        actualTranslations={props.actualTranslations}
                        onlyItem={props.isButtons}
                     />
                  ) : props.isButtons ? (
                     <Button
                        buttonType="primary"
                        onClick={() => {
                           if (
                              action?.label?.includes("Rezerwuj") ||
                              action?.label.processId === "326"
                           ) {
                              handleSave();
                              return;
                           }
                           handleClick(action);
                        }}
                     >
                        {action?.label}
                     </Button>
                  ) : (
                     <a
                        onClick={() => {
                           if (
                              action?.label?.includes("Rezerwuj") ||
                              action?.label.processId === "326"
                           ) {
                              handleSave();
                              return;
                           }
                           handleClick(action);
                        }}
                     >
                        {action?.label}
                     </a>
                  )}
               </Menu.Item>
            ))}
         </Menu>
      ),
      [props.isButtons, allActions]
   );

   const dropdownMenu = useMemo(
      () =>
         allActions.map((action, index) =>
            action?.type === "FORM"
               ? {
                    id: action.id ?? index,
                    name: (
                       <ActionModal
                          action={action}
                          props={props}
                          actualTranslations={props.actualTranslations}
                          onlyItem={props.isButtons}
                       />
                    )
                 }
               : action?.type === "chat"
               ? {
                    id: action.id ?? index,
                    name: (
                       <CreateChat
                          action={action}
                          props={props}
                          actualTranslations={props.actualTranslations}
                          onlyItem={props.isButtons}
                       />
                    )
                 }
               : props.isButtons
               ? {
                    id: action.id ?? index,
                    name: <Button buttonType="primary">{action?.label}</Button>,
                    onClick: () => {
                       if (
                          action?.label?.includes("Rezerwuj") ||
                          action?.label.processId === "326"
                       ) {
                          handleSave();
                          return;
                       }
                       handleClick(action);
                    }
                 }
               : {
                    id: action.id ?? index,
                    name: <a>{action?.label}</a>,
                    onClick: () => {
                       if (
                          action?.label?.includes("Rezerwuj") ||
                          action?.label.processId === "326"
                       ) {
                          handleSave();
                          return;
                       }
                       handleClick(action);
                    }
                 }
         ),
      [props.isButtons, allActions]
   );

   if (props.isButtons) return menu;

   return (
      <div className="actions-dropdown">
         {props?.actions && props?.actions?.length > 1 ? (
            isHoppyOrGamification() ? (
               <Button
                  buttonType="primary"
                  className="gx-m-0"
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
               >
                  <i className="icon icon-menu gx-flex-row gx-justify-content-center" />
                  <Dropdown
                     items={dropdownMenu}
                     isOpen={isDropdownOpen}
                     setIsOpen={setIsDropdownOpen}
                  />
               </Button>
            ) : (
               <Button buttonType="primary" onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
                  {props?.title}
                  <Dropdown
                     items={dropdownMenu}
                     isOpen={isDropdownOpen}
                     setIsOpen={setIsDropdownOpen}
                  />
               </Button>
            )
         ) : (
            <>
               {allActions.length > 1 ? (
                  isHoppyOrGamification() ? (
                     <Button
                        buttonType="primary"
                        className="gx-m-0"
                        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                     >
                        <i className="icon icon-menu gx-flex-row gx-justify-content-center" />
                        <Dropdown
                           items={dropdownMenu}
                           isOpen={isDropdownOpen}
                           setIsOpen={setIsDropdownOpen}
                        />
                     </Button>
                  ) : (
                     <Button
                        buttonType="primary"
                        className="gx-m-0"
                        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                     >
                        {props?.title}
                        <Dropdown
                           items={dropdownMenu}
                           isOpen={isDropdownOpen}
                           setIsOpen={setIsDropdownOpen}
                        />
                     </Button>
                  )
               ) : allActions.length === 1 && props.isChatButtonVisible === true ? (
                  <CreateChat
                     action={{ type: "chat", isChatButtonVisible: true }}
                     props={props}
                     actualTranslations={props.actualTranslations}
                     onlyItem={props.isButtons}
                  />
               ) : props.actions[0]?.type === "FORM" ||
                 props.actions[0]?.cloudConnections === "1" ? (
                  <ActionModal action={props?.actions?.[0]} props={props} onlyItem />
               ) : (
                  props?.actions?.[0] && (
                     <Button
                        buttonType="primary"
                        onClick={() => handleClick(props?.actions?.[0], click)}
                     >
                        {props?.actions?.[0]?.label}
                     </Button>
                  )
               )}
            </>
         )}
      </div>
   );
};
export default ActionsDropdown;
